export default function getPathWithTrailingSlash(path: string) {
  // path//// -> path/
  return path.trim().replace(/\/+$/, '') + '/';
}
